import basicController from 'servicestack/basic.controller.properties'

export default class MediaManagerPromptController {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        Object.assign($ctrl, options);
        console.debug('MediaManagerPromptController', this);
    }
}